import { GraphQLClient } from 'graphql-request'

import ENDPOINTS from '@/constants/endpoints'

const Hasura = new GraphQLClient(ENDPOINTS.GRAPHQL, {
  credentials: 'include',
})

export default Hasura
